import { isMobileAgent } from './userAgent'

export const isMobileDevice = (): boolean => {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false
  }

  const userAgent = (
    navigator.userAgent ||
    navigator.vendor ||
    (window as any).opera ||
    ''
  ).toLowerCase()

  return isMobileAgent(userAgent)
}
